// src/pages/ServicesPage/ServicesPage.jsx
import React from 'react';
import Cta from '../../components/sections/Cta/Cta';
import Clients from '../../components/sections/Clients/Clients'
import WhyChooseUs from '../../components/sections/WhyChooseUs/WhyChooseUs';
import CoreVitalsSection from '../../components/sections/FeaturedServices/FeaturedServices';
import IndustryExpertise from '../../components/sections/IndustryExpertise/IndustryExpertise';
import Services from '../../components/sections/Services/Services';
import Pricing from '../../components/sections/Pricing/Pricing';
import DesignGallery from '../../components/sections/DesignGallery/DesignGallery';
const ServicesPage = () => {
    return (
        <>
            <WhyChooseUs />
            <Services />
            <Clients />
            <Pricing />
            <CoreVitalsSection />
            <IndustryExpertise />
            <DesignGallery />
            <Cta />
        </>
    );
};

export default ServicesPage;